module.exports = __webpack_public_path__ + "static/media/efreixevry.7f0b8ea2.png";